function pad6(num) {
    return String(num).padStart(6, '0');
}

function padId(id) {
    return id ? `#${String(id).padStart(4, '0')}` : '#00000';
}

export function formatJournalForPrint(journalData) {
    let lines = [];

    const now = new Date();
    const todayStr = `${now.getFullYear()}年${now.getMonth()+1}月${now.getDate()}日 ${now.getHours()}時${now.getMinutes()}分`;
    const targetDate = journalData.length > 0 ? new Date(journalData[0].datetime) : now;
    const targetDateStr = `${targetDate.getFullYear()}年${targetDate.getMonth()+1}月${targetDate.getDate()}日`;

    lines.push(todayStr);
    lines.push('電子ジャーナル');
    lines.push(`日付：${targetDateStr}`);
    lines.push('=========================================');

    journalData.forEach(entry => {
        const dt = new Date(entry.datetime);
        const dateStr = `${dt.getFullYear()}年${dt.getMonth()+1}月${dt.getDate()}日 ${dt.getHours().toString().padStart(2, '0')}:${dt.getMinutes().toString().padStart(2, '0')}`;

        if (entry.type === 'sale') {
            lines.push(`${dateStr}` + `レジNO:${entry.register_id}`.padStart(20, ' '));
            lines.push(`レシートNo: ${pad6(entry.id)}`);
            if (entry.is_tax_free) {
                lines.push('-----------------------------------------');
                lines.push('　          　【TAX-FREE】');
                lines.push('-----------------------------------------');
            }
            lines.push('商品名                       数量    金額');
            entry.details.forEach(d => {
                // inventory_id, quantity, priceのフォーマット調整
                const idStr = padId(d.inventory_id).padEnd(6, ' ');  // 最大6桁に調整（後ろにスペースを追加）
                const quantityStr = String(d.quantity).padStart(4, ' ');  // 最大4桁に調整（前にスペースを追加）
                const priceStr = `¥${d.unit_price.toLocaleString()}`.padStart(8, ' ');  // 最大6桁に調整（前にスペースを追加）

                let nameStr = d.product_name;
                if (nameStr.length > 9) {
                    nameStr = nameStr.slice(0, 9) + '…';  // 商品名が長い場合は切り捨て
                } else {
                    nameStr = nameStr.padEnd(16, ' ');  // 商品名が短い場合は後ろにスペースを追加
                }

                // 商品名、数量、金額を40文字以内に収める
                lines.push(`${idStr} ${nameStr} ${quantityStr} ${priceStr}`);
                if (d.discount > 0) {
                    lines.push(`値引`.padStart(31, ' ') + `-¥${d.discount.toLocaleString()}`.padStart(8, ' '));
                }
            });
            lines.push('-----------------------------------------');
            lines.push(`買上点数` + `${String(entry.item_count).padStart(2)}`.padStart(32, ' '));
            lines.push(`小計` + `¥${entry.subtotal.toLocaleString()}`.padStart(37, ' '));
            lines.push(`消費税` + `¥${entry.tax.toLocaleString()}`.padStart(35, ' '));
            if (entry.tax_free > 0) {
                lines.push(`免税額` + `-¥${entry.tax.toLocaleString()}`.padStart(35, ' '));
            }
            lines.push(`合計` + `¥${entry.total.toLocaleString()}`.padStart(37, ' '));
            lines.push('-----------------------------------------');
            lines.push(`支払方法`);
            lines.push(`${entry.payment_method === 'cash' ? '現金' + `¥${entry.amount_paid.toLocaleString()}`.padStart(37, ' ') : 'キャッシュレス' + `¥${entry.amount_paid.toLocaleString()}`.padStart(27, ' ')}`);
            lines.push(`おつり` + `¥${entry.change.toLocaleString()}`.padStart(35, ' '));
        } else {
            const label = {
                deposit: '入金',
                withdrawal: '出金',
                purchase: '買取',
                expenses: '経費',
                refund: '返金',
                purchase_payment: '買取支払い'
            }[entry.type] || 'その他';

            lines.push(`${pad6(entry.id)} ${dateStr}`);
            lines.push(`${label} ¥${entry.amount.toLocaleString()}`);
        }

        lines.push('');
    });

    return lines.join('\n');
}
